<template>
    <people-athlete :people="athletes" @updateChosen="chosen => chosenAthlete = chosen">
        <template slot="chosen-card">
            <chosen-person v-if="chosenAthlete.firstName"
                           :categories="athleteInfoTextById[chosenAthlete.id] && athleteInfoTextById[chosenAthlete.id].category ? athleteInfoTextById[chosenAthlete.id].category.split(',') : []"
                           :connected-people="athleteCoachMapping[chosenAthlete.id]"
                           connected-people-headline="Trainer"
                           :first-name="chosenAthlete.firstName"
                           :last-name="chosenAthlete.lastName"
                           :img="$helper.imgServerUrl() + chosenAthlete.img"
                           :info-text="athleteInfoTextById[chosenAthlete.id] ? athleteInfoTextById[chosenAthlete.id].info : ''">
                <template slot="container">
                    <athlete-trophy-table
                            :trophy-list="trophyByUser[chosenAthlete.id] ? trophyByUser[chosenAthlete.id] : []"></athlete-trophy-table>
                </template>
            </chosen-person>
        </template>
    </people-athlete>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import AthleteTrophyTable from "../content/club/athlete/trophy/TrophyTable";
    import People from "../content/club/people/People";
    import ChosenPerson from "../content/club/people/ChosenPerson";
    import PeopleAthlete from "../content/club/people/PeopleAthlete";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "AthleteCoach",
        components: {PeopleAthlete, ChosenPerson, People, AthleteTrophyTable},
        computed: {
            ...mapGetters(['athletes', 'athleteInfoTextById', 'trophyByUser', 'athleteCoachMapping'])
        },
        directives: {
            Resize, Scroll
        },
        data() {
            return {
                chosenAthlete: {},
            }
        },
        methods: {
            ...mapActions(['getAllUsers', 'getAthleteInfoText', 'getCoachAthleteMapping', 'getTrophyList']),
        },
        mounted() {
            if (this.athletes.length === 0) {
                this.getAllUsers()
            }
            if (!(this.athletes.length > 0 && this.athleteInfoTextById > 0 && this.trophyByUser > 0 && this.athleteCoachMapping > 0)) {
                this.getAthleteInfoText()
                this.getCoachAthleteMapping()
                this.getTrophyList()
            }

            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)

        }
    }
</script>
<style>
    .img-transition .v-image__image--cover {
        transition: all .5s ease-in-out 0s;
    }

    .max-40 {
        max-height: 40vh;
        overflow: auto;
    }

    .max-60 {
        max-height: 60vh;
        overflow: auto;
    }

    #top-people > div > div.layout.align-senter.justify-center.transition > div > div > div > div.flex.xs3 > div:nth-child(n) {
        max-width: 100%;
        overflow: auto;
    }

</style>
